import { isValidPassword } from 'shared/helpers/Validators';
export const validAgentPassword = (password, confirmation) =>
  password.length >= 6 &&
  password.length <= 128 &&
  isValidPassword(password) &&
  password === confirmation;
export const agentPasswordError = (error, t) => {
  const code = error?.response?.data?.code;
  const known = [
    'INVALID_PASSWORD_INPUT',
    'PASSWORD_CONFIRMATION_MISMATCH',
    'LOCAL_PASSWORD_UNAVAILABLE',
    'EXISTING_USER_PASSWORD',
  ];
  if ([401, 403].includes(error?.response?.status))
    return t('AGENT_PASSWORD.ERRORS.FORBIDDEN');
  return t(
    known.includes(code)
      ? `AGENT_PASSWORD.ERRORS.${code}`
      : 'AGENT_PASSWORD.ERRORS.DEFAULT'
  );
};
